import { GetStaticPaths, GetStaticProps, GetServerSideProps, InferGetStaticPropsType, NextPage } from 'next';
import { useRouter } from 'next/router';

// Components
import { Layout } from 'components/common';
import { ProductView } from 'components/product';

// Services
import { getProducts, getProductByUniqueName, getProductsByRelations } from 'services/storm';

// Utils
import { ProductDetail, ProductRelations } from 'interfaces/Storm/ProductDetail';
import { getContentfulSettings, getContentfulCategoryId } from 'services/contentful';
import { CfCategory, CfSettings } from 'interfaces/Contentful';
import { convertReqToBearerToken } from 'utils/authUtil';

interface Props {
  settings: CfSettings;
  product: ProductDetail;
  category: CfCategory | null;
  productRelations: ProductRelations[];
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ params, locale, req, res }) => {

  if (!params?.slug) {
    return {
      notFound: true,
    };
  }

  const slug = Array.isArray(params.slug) ? params.slug[0] : params.slug;
  const product = await getProductByUniqueName(slug, {
    headers: {
      Authorization: convertReqToBearerToken(req),
    },
  });

  // If there is no product return a 404
  if (!product.data) {
    return {
      notFound: true,
    };
  }

  const settings = await getContentfulSettings(locale);
  const productByRelations = await getProductsByRelations(product.data.id, {
    headers: {
      Authorization: convertReqToBearerToken(req)
    }
  });

  // Initialize a static props that we can adjust need be
  const staticProps: Props = {
    settings: settings.data,
    product: product.data,
    category: null,
    productRelations: productByRelations.data,
  };

  // Check if there is a category id to the product
  if (product.data?.category?.externalId) {
    try {
      const contentfulCategory = await getContentfulCategoryId(product.data.category.externalId);
      // If there is a contentful category containing this category id then we attach it the response
      staticProps.category = contentfulCategory.data;
    } catch (error) {
      // If there is NOT a contentful category we do nothing but log it
    }
  }

  // res.setHeader('Cache-Control', 'public, s-maxage=300, stale-while-revalidate=60');

  return {
    props: staticProps,
    // revalidate: 60 * 10, // 10 minutes
  };
};

// export const getStaticProps: GetStaticProps<Props> = async ({ params, locale }) => {
//   if (!params?.slug) {
//     return {
//       notFound: true,
//     };
//   }

//   const slug = Array.isArray(params.slug) ? params.slug[0] : params.slug;
//   const product = await getProductByUniqueName(slug);
//   const settings = await getContentfulSettings(locale);

//   // If there is no product return a 404
//   if (!product.data) {
//     return {
//       notFound: true,
//     };
//   }

//   // Initialize a static props that we can adjust need be
//   const staticProps: Props = {
//     settings: settings.data,
//     product: product.data,
//     category: null,
//   };

//   // Check if there is a category id to the product
//   if (product.data?.category?.externalId) {
//     try {
//       const contentfulCategory = await getContentfulCategoryId(product.data.category.externalId);
//       // If there is a contentful category containing this category id then we attach it the response
//       staticProps.category = contentfulCategory.data;
//     } catch (error) {
//       // If there is NOT a contentful category we do nothing but log it
//     }
//   }

//   return {
//     props: staticProps,
//     revalidate: 60 * 10, // 10 minutes
//   };
// };

// export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
//   const productsResponse = await getProducts();
//   const products = productsResponse.data.items;

//   let paths: { params: { slug: string }; locale?: string }[] = [];
//   if (locales) {
//     paths = locales.reduce((accum, locale) => {
//       products.forEach((p) => {
//         accum.push({ params: { slug: p.uniqueName }, locale: locale });
//       });

//       return accum;
//     }, paths);
//   } else {
//     paths = products.reduce((accum, p) => {
//       accum.push({ params: { slug: p.uniqueName } });
//       return accum;
//     }, paths);
//   }

//   return {
//     paths,
//     fallback: true,
//   };
// };

const ProductPage: NextPage<InferGetStaticPropsType<typeof getServerSideProps>> = ({
  product,
  category,
  productRelations,
}) => {
  const router = useRouter();
  return router.isFallback ? (
    <h1>Loading...</h1>
  ) : (
    <ProductView product={product} category={category} productRelations={productRelations} />
  );
};

// @ts-ignore custom implementation that NextPage doesn't cover
ProductPage.Layout = Layout;

export default ProductPage;
